// Download a URL to disk as `filename` via a blob, so the saved file keeps its
// name regardless of the server's Content-Disposition. Falls back to opening the
// URL in a new tab if the fetch is blocked (CORS/offline). Shared by the image
// and PDF preview modals.
export const downloadFile = async (url: string, filename: string): Promise<void> => {
	try {
		const res = await fetch(url);
		if (!res.ok) throw new Error(`HTTP ${res.status}`);
		const blob = await res.blob();
		const objectUrl = URL.createObjectURL(blob);
		const a = document.createElement('a');
		a.href = objectUrl;
		a.download = filename;
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
		URL.revokeObjectURL(objectUrl);
	} catch (err) {
		// Don't swallow — surface why the in-app download failed before falling back.
		console.error('downloadFile: blob download failed, opening in a new tab instead', { url, err });
		window.open(url, '_blank', 'noopener,noreferrer');
	}
};
